import React from 'react'

import Grid from 'components/Grid'
import LastUpdatedDate from 'components/LastUpdatedDate'
import Typography from 'components/Typography'
import { useListingDetailContext } from 'context/ListingDetailContext'

import Contributors from './Contributors'

import classes from './RichContentTitle.module.scss'

/** @type {import("./types").default} */
const RichContentTitle = ({ richContent }) => {
  const { listing } = useListingDetailContext()

  return (
    <Grid container className={classes.root}>
      <Grid item xs={12}>
        <Typography component="h1" className={classes.title}>
          {listing.name} Review {richContent.titleYear}: Pricing, Features & Alternatives
        </Typography>
      </Grid>
      <Grid container className={classes.authorsContainer}>
        <div className={classes.contributorsContainer}>
          <Contributors type="WRITERS" contributors={richContent.writers} />
        </div>
        <div className={classes.contributorsContainer}>
          <Contributors type="EDITORS" contributors={richContent.editors} />
        </div>
      </Grid>
      <Grid item xs={12}>
        <LastUpdatedDate lastUpdatedDate={richContent.lastUpdate} />
      </Grid>
    </Grid>
  )
}

export default RichContentTitle
